import { type FormikValues, type FormikErrors } from 'formik';
import React, { cloneElement } from 'react';

interface FormikReactSelectWrapperProps<FormDataT extends FormikValues> {
  children: React.ReactElement;
  name: string;
  setFieldTouched: (
    field: string,
    touched?: boolean,
  ) => Promise<FormikErrors<FormDataT>> | Promise<void>;
  setFieldValue: (
    field: string,
    value: any,
  ) => Promise<FormikErrors<FormDataT>> | Promise<void>;
  values: FormDataT;
}

export const FormikHooksReactSelectWrapper = <FormDataT extends FormikValues>({
  children,
  name,
  setFieldTouched,
  setFieldValue,
  values,
}: FormikReactSelectWrapperProps<FormDataT>) => {
  return cloneElement(children, {
    ...children.props,
    value: values[name],
    onChange: (option: { value: string } | null) => {
      setFieldValue(name, option?.value ?? null);
      children.props.onChange?.(option);
    },
    onBlur: () => {
      setFieldTouched(name, true);
      children.props.onBlur?.();
    },
  });
};
